import { StyledMainImageContainer, StyledProductPhotoGallery } from "./styles";

import { ApiImageUrl } from "@features/api";
import React, { FC, memo, useEffect, useRef, useState } from "react";
import { MainProductImage } from "../MainProductImage";

interface ProductPhotoGalleryProps {
  className?: string;
  style?: React.CSSProperties;
  photos: ApiImageUrl[];
  productName: string;
  mainImage: string;
}

import { FlexibleSlider } from "@components/FlexibleSlider/dynamic";
import { useWindowWidth } from "@features/adaptive/useWindowWidth";
import { MainImageImagePlaceholder } from "../MainImageImagePlaceholder/dynamic";
import { SidebarGallery } from "../SidebarGallery/dynamic";
import { useGetSidebarImages } from "../SidebarGallery/hooks";

const _ProductPhotoGallery: FC<ProductPhotoGalleryProps> = (props) => {
  const { photos, mainImage, productName, ...restProps } = props;

  const mainImageAndPhotosGallery = [mainImage].concat(photos);

  const [current, setCurrent] = useState<string | null>(
    mainImageAndPhotosGallery[0]
  );
  const [mainImageHeight, setMainImageHeight] = useState<number>(0);

  const imageContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    setCurrent(mainImage);

    if (imageContainerRef.current) {
      setMainImageHeight(imageContainerRef.current?.clientHeight);
    }
  }, [mainImage]);

  const width = useWindowWidth();

  const isDesktop = width === "desktop";

  const items = useGetSidebarImages({
    current,
    setCurrent,
    productName,
    images: mainImageAndPhotosGallery,
  });

  const itemsLength = items ? items.length : 0;

  const itemsPerRow = isDesktop ? 6 : 8;

  const renderItem =
    itemsLength < 6 ? (
      <SidebarGallery items={items} />
    ) : (
      items && (
        <FlexibleSlider
          maxWidthHeight={mainImageHeight}
          items={items}
          itemsPerRow={itemsPerRow}
          direction="column"
        />
      )
    );

  return (
    <StyledProductPhotoGallery {...restProps}>
      {renderItem}
      <StyledMainImageContainer ref={imageContainerRef}>
        {current ? (
          <MainProductImage
            src={current}
            alt={productName}
            title={`изображение - ${productName}`}
          />
        ) : (
          <MainImageImagePlaceholder />
        )}
      </StyledMainImageContainer>
    </StyledProductPhotoGallery>
  );
};

export const ProductPhotoGallery = memo(_ProductPhotoGallery);
